import gsap from 'gsap';
import { useCreateOptions, computedScrollTop } from '../../solutionsDetail/context';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EfImg from 'elem/ui/ef-img';

const { EFPic } = createEFPic('/img/landingPage/');

export default function Index({ item }: any) {
    const { useLang, useRouter, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('landingPage');
    const { img, name, device, power, desc, buyLink } = item;

    const { setActiveValue } = useCreateOptions(t);

    const onFixedNavChange = (item: any) => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'select_product',
                list_name: t('delta_pro_whole_home.solution_title'),
                product_name: item.device,
                button_name: t('learn_more'),
            });
        } catch (e) {
            console.log(e);
        }
        setActiveValue(item?.id);
        gsap.to(document.documentElement, { duration: 1, scrollTo: { y: computedScrollTop(item?.id) } });
    };

    const handleBuy = () => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: device,
                position: `Solution Page_${t('delta_pro_whole_home.solution_title')}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
        window.open(buyLink);
    };
    return (
        <div className={css.swiperCard}>
            <div className="content">
                <div className="img-box">
                    {String(img)?.startsWith('https://') ? <EfImg pc={img} /> : <EFPic name={[`${img}.png`, `${img}.png`]} alt={`${device}`} />}
                </div>
                <div className="name">{name}</div>
                <div className="device">{device}</div>
                <div className="power">{power}</div>
                <div className="desc">{desc}</div>
                <div className="options">
                    {locale === 'au' ? (
                        <Link href={buyLink} className="learn-more">
                            {t('learn_more')}
                        </Link>
                    ) : (
                        <div className="learn-more" onClick={() => onFixedNavChange(item)}>
                            {t('learn_more')}
                        </div>
                    )}
                    {buyLink && locale !== 'au' && (
                        <div className="buy-now" onClick={() => handleBuy()}>
                            {t('buy_now')}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
